export default __webpack_public_path__ + "static/media/plataforma_fondo2.253154d4.png";